import React, { useEffect, useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { StepIndicator } from '../../components/StepIndicator';
import { CheckCircleIcon, ImageIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Select Product', 'Background', 'Greetings', 'Store Info', 'Generate', 'Output Format'];
export function GenerateCreative() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [currentStep, setCurrentStep] = useState('Initializing...');
  useEffect(() => {
    const steps = [{
      label: 'Composing product and background...',
      duration: 1000
    }, {
      label: 'Adding greeting text...',
      duration: 800
    }, {
      label: 'Applying store information...',
      duration: 800
    }, {
      label: 'Finalizing creative...',
      duration: 600
    }];
    let currentProgress = 0;
    let stepIndex = 0;
    const interval = setInterval(() => {
      if (stepIndex < steps.length) {
        setCurrentStep(steps[stepIndex].label);
        const increment = 100 / steps.length;
        currentProgress += increment;
        setProgress(Math.min(currentProgress, 100));
        stepIndex++;
      } else {
        clearInterval(interval);
        setIsComplete(true);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1651">
      <Sidebar data-id="element-1652" />
      <main className="flex-1" data-id="element-1653">
        <Header data-id="element-1654" />
        <StepIndicator currentStep={5} steps={STEPS} data-id="element-1655" />
        <div className="px-6 py-8" data-id="element-1656">
          <div className="max-w-4xl mx-auto" data-id="element-1657">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1658">
              Step 5: Generate Creative
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1659">
              AI is generating your brand-compliant creative
            </p>

            {!isComplete ? <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-1660">
                <div className="text-center mb-8" data-id="element-1661">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1662">
                    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" data-id="element-1663"></div>
                  </div>
                  <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-1664">
                    {currentStep}
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1665">
                    This will only take a moment...
                  </p>
                </div>

                <div className="mb-4" data-id="element-1666">
                  <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-1667">
                    <span data-id="element-1668">Progress</span>
                    <span data-id="element-1669">{Math.round(progress)}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3" data-id="element-1670">
                    <div className="bg-blue-500 h-3 rounded-full transition-all duration-500" style={{
                  width: `${progress}%`
                }} data-id="element-1671"></div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-6" data-id="element-1672">
                  <h4 className="font-medium text-blue-900 mb-2" data-id="element-1673">
                    What's Happening?
                  </h4>
                  <ul className="text-sm text-blue-800 space-y-1" data-id="element-1674">
                    <li data-id="element-1675">• Composing product with selected background</li>
                    <li data-id="element-1676">• Adding greeting text with brand styling</li>
                    <li data-id="element-1677">• Applying store information in pre-set positions</li>
                    <li data-id="element-1678">• Ensuring brand compliance</li>
                  </ul>
                </div>
              </div> : <div className="space-y-6" data-id="element-1679">
                <div className="bg-green-50 border border-green-200 rounded-lg p-6" data-id="element-1680">
                  <div className="flex items-center" data-id="element-1681">
                    <CheckCircleIcon className="text-green-500 mr-3 flex-shrink-0" size={32} data-id="element-1682" />
                    <div data-id="element-1683">
                      <h3 className="text-lg font-medium text-green-900" data-id="element-1684">
                        Creative Generated Successfully!
                      </h3>
                      <p className="text-sm text-green-700" data-id="element-1685">
                        Your brand-compliant creative is ready
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1686">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1687">Preview</h3>
                  <div className="flex justify-center" data-id="element-1688">
                    <div className="w-96 h-96 bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex items-center justify-center border-2 border-gray-200" data-id="element-1689">
                      <ImageIcon className="text-gray-400" size={64} data-id="element-1690" />
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 text-center mt-4" data-id="element-1691">
                    Static image creative with all your customizations
                  </p>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1692">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1693">
                    Creative Details
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1694">
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1695">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1696">Format</p>
                      <p className="font-semibold text-gray-800" data-id="element-1697">
                        Square (1:1)
                      </p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1698">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1699">Resolution</p>
                      <p className="font-semibold text-gray-800" data-id="element-1700">
                        1080 x 1080 px
                      </p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1701">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1702">
                        Brand Compliance
                      </p>
                      <p className="font-semibold text-green-600" data-id="element-1703">✓ Verified</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1704">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1705">File Size</p>
                      <p className="font-semibold text-gray-800" data-id="element-1706">~2.5 MB</p>
                    </div>
                  </div>
                </div>

                <div className="flex justify-between" data-id="element-1707">
                  <button onClick={() => navigate('/dealer/ai-generator/step-4')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1708">
                    Back to Edit
                  </button>
                  <button onClick={() => navigate('/dealer/ai-generator/step-6')} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" data-id="element-1709">
                    Continue to Output Format
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </main>
    </div>;
}